module.exports = __webpack_public_path__ + "static/media/mat-min.4a9251df.png";